import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FN01 {
  fn01_01: string;        // 客訴類型代號 (N202)
  fn01_02: string;        // 客訴處理代號 (3碼)
  fn01_11: string;        // 客訴處理要求（中文）
  fn01_12: string;        // 客訴處理要求（英文）
  fn01_91: string;        // 建立人員
  fn01_92: string | null; // 建立日期
  fn01_93: string;        // 修改人員
}

export interface CreateRequest {
  fn01_02: string;
  fn01_11: string;
  fn01_12?: string;
}

export interface UpdateRequest {
  fn01_11: string;
  fn01_12?: string;
}

export interface ListResponse {
  data: FN01[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const complaintReqApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/complaint-req', { params });
    return res.data;
  },

  async get(code: string): Promise<FN01> {
    const res = await apiClient.get(`/api/complaint-req/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FN01> {
    const res = await apiClient.post('/api/complaint-req', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FN01> {
    const res = await apiClient.put(`/api/complaint-req/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/complaint-req/${encodeURIComponent(code)}`);
  },
};
